<app-header></app-header>
<div class="wrapper">
  <section class="related-search upcoming mt-4" *ngIf="shimarStatus">
    <div class="container" *ngIf="recommendedData?.length === 0">
      <div class="record-not-available">
        <div class="text-center">
          <img src="assets/images/no-recoard-playlist.png" />
          <p class="no-recored-content text-secondary">
            {{ "RECORD_NOT_FOUND" | translate }}
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="loadMore" class="w-100">
      <article class="related-search sim-gallery">
        <div class="container">
          <div class="row custome-set mb-3">
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
          </div>
        </div>
      </article>
    </div>
  </section>
  <section class="related-search mt-4" #vcontent [hidden]="shimarStatus">
    <div class="container" *ngIf="!shimarStatus">
      <div class="section-head col-12">
        <h2>{{ "RECOMMENDED_LIST.RECOMMENDED_FOR_YOU" | translate }}</h2>
      </div>
      <div class="row custome-set">
        <div class="series-box" *ngFor="let show of recommendedData">
          <app-grid [data]="show" [gridType]="'landscape'"></app-grid>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer></app-footer>
